module.exports = __webpack_public_path__ + "img/film-default.985bf5f8.jpg";